import _Promise from 'babel-runtime/core-js/promise';

import { chooseIfOptions,
// renderType,
priorityOptions, stageOptions, compressOptions } from '@/common/material-metadata';

var cookOptions = function cookOptions(list) {
  return list.map(function (item) {
    item.border = true;
    return item;
  });
};
export default {
  components: {},

  props: {
    formValue: {
      type: Object,
      required: true
    },
    selectTasks: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    materialSource: {
      type: Number
    }
  },

  data: function data() {
    return {
      formConfig: {
        labelWidth: '150px'
      },
      basicPackFormItemList: [{
        visible: function visible(_ref) {
          var formValue = _ref.formValue;

          // 如果存在source_id的值，不显示该选项
          return !formValue.source_id;
        },
        label: '选择已有基础包：',
        type: 'radio-group',
        prop: 'choose_base',
        params: {
          disabled: false,
          options: cookOptions(chooseIfOptions),
          button: false,
          border: true
        }
      }, {
        visible: function visible(_ref2) {
          var formValue = _ref2.formValue;

          // 如果存在source_id的值，显示该选项
          return formValue.source_id;
        },
        label: '素材来源：',
        type: 'plain-text',
        prop: 'source_type_text'
      }, {
        visible: function visible(_ref3) {
          var formValue = _ref3.formValue;

          // 如果存在source_id的值，显示该选项
          return formValue.source_id;
        },
        label: '来源包id：',
        type: 'plain-text',
        prop: 'source_id'
      }, {
        visible: function visible(_ref4) {
          var formValue = _ref4.formValue;

          // 如果存在source_id的值，不显示该选项
          return !formValue.source_id && formValue.choose_base === 1 && formValue.source_type !== 3;
        },
        label: '请选择基础包：',
        type: 'business',
        subtype: 'basic-pack-selector',
        prop: 'basic_id',
        params: {
          width: '100%'
        },
        rules: [{
          required: true,
          message: '请选择基础包',
          trigger: 'change'
        }]
      }, {
        visible: function visible(_ref5) {
          var formValue = _ref5.formValue;

          return !formValue.source_id && formValue.choose_base === 0 && formValue.source_type !== 3;
        },
        label: '请上传基础包：',
        type: 'business',
        subtype: 'single-file-uploader',
        prop: 'basic_file',
        rules: [{
          required: true,
          message: '请选择上传基础包',
          trigger: 'blur'
        }],
        params: {
          disabled: false,
          drag: true,
          'with-credentials': true,
          accept: 'application/zip,application/x-zip,application/x-zip-compressed,application/octet-stream',
          tip: '只能上传zip文件',
          fileList: []
        }
      }]
    };
  },


  computed: {
    isCanCompress: function isCanCompress() {
      if (!this.selectTasks.length) return false;
      // 只有自研素材才支持压缩
      if (this.materialSource !== 2) return false;
      // 只有categoryid 是1,2,3的时候才支持压缩
      var canCompress = [1, 2, 3];
      return canCompress.indexOf(this.selectTasks[0].category_id) !== -1 && this.formValue.is_self_test === 0;
    },
    configureFormItemList: function configureFormItemList() {
      var _this = this;

      return [
      // {
      //   visible: ({ formValue }) => {
      //     // 如果存在source_id的值，显示该选项
      //     return formValue.source_type !== 3
      //   },
      //   label: '渲染模式：',
      //   type: 'radio-group',
      //   prop: 'render_type',
      //   params: ({ formValue }) => {
      //     return {
      //       disabled: formValue.choose_base === 1,
      //       options: cookOptions(renderType),
      //       button: false,
      //       border: true,
      //     }
      //   },
      // },
      // {
      //   label: '阶段信息：',
      //   type: 'radio-group',
      //   prop: 'isSupportStage',
      //   params: ({ formValue }) => {
      //     return {
      //       disabled: formValue.choose_base === 1,
      //       options: [
      //         {
      //           label: '支持',
      //           value: 1,
      //         },
      //         {
      //           label: '不支持',
      //           value: 0,
      //         },
      //       ],
      //     }
      //   },
      //   rules: [
      //     {
      //       required: true,
      //       message: '请选择是否支持阶段信息',
      //       trigger: 'change',
      //     },
      //   ],
      // },
      {
        visible: function visible(_ref6) {
          var formValue = _ref6.formValue;

          return formValue.isSupportStage === 1;
        },
        type: 'checkbox-group',
        prop: 'stage',
        params: function params(_ref7) {
          var formValue = _ref7.formValue;

          return {
            multiple: true,
            disabled: formValue.choose_base === 1,
            options: stageOptions
          };
        },
        rules: [{
          required: true,
          message: '请选择支持阶段',
          trigger: 'change'
        }]
      }, {
        visible: function visible(_ref8) {
          var formValue = _ref8.formValue;

          // 如果存在source_id的值，显示该选项
          return formValue.source_type !== 3;
        },
        label: '基础包标签：',
        type: 'business',
        subtype: 'base-package-tag-checkbox',
        prop: 'tag_ids',
        params: function params(_ref9) {
          var formValue = _ref9.formValue;

          return {
            disabled: formValue.choose_base === 1,
            border: true
          };
        }
      }, {
        label: '优先级：',
        type: 'radio-group',
        prop: 'priority',
        params: {
          options: cookOptions(priorityOptions),
          button: false,
          border: true
        }
      }, {
        label: '是否压缩：',
        type: 'radio-group',
        prop: 'is_compress',
        params: function params(_ref10) {
          var formValue = _ref10.formValue;

          return {
            disabled: !_this.isCanCompress,
            options: cookOptions(compressOptions.slice(0, 1)),
            button: false,
            border: true
          };
        }
      }, {
        label: '是否自测：',
        type: 'radio-group',
        prop: 'is_self_test',
        params: function params(_ref11) {
          var formValue = _ref11.formValue;

          return {
            options: cookOptions(chooseIfOptions),
            button: false,
            border: true
          };
        }
      }, {
        visible: function visible(_ref12) {
          var formValue = _ref12.formValue;

          return formValue.is_self_test === 0;
        },
        label: '选择测试人员：',
        type: 'business',
        subtype: 'tester-selector',
        prop: 'tester_id',
        rules: [{
          required: true,
          message: '请选择测试人员',
          trigger: 'change'
        }]
      }];
    }
  },

  watch: {
    isCanCompress: {
      handler: function handler(val) {
        // eslint-disable-next-line vue/no-mutating-props
        this.formValue.is_compress = 3;
      },

      immediate: true
    }
  },

  methods: {
    validate: function validate() {
      var promiseArray = [];
      promiseArray.push(this.$refs['basicPackForm'].validate());
      promiseArray.push(this.$refs['configureForm'].validate());
      return _Promise.all(promiseArray);
    }
  }
};